module.exports = __webpack_public_path__ + "static/assets/a094c7a00b1aa87f9b904d2f913bbe40.svg";